import React, { memo } from 'react'
import { Link } from 'react-router-dom'

function EmptyListState({ title, message, actionLabel, actionTo, permissionHint }) {
  return (
    <div className="empty-list-state text-center text-cream p-4 my-4" role="status">
      <h2 className="h4">{title}</h2>
      <p className="lead mb-3">{message}</p>
      {permissionHint ? <p className="small text-muted">{permissionHint}</p> : null}
      {actionLabel && actionTo ? (
        <Link className="btn bt-cream" to={actionTo}>{actionLabel}</Link>
      ) : null}
    </div>
  )
}

export default memo(EmptyListState)
